import { useEffect, useRef, useState } from 'react';

/**
 *
 * I had to make use of both resize and resize observer
 *
 * Resize observer updates the state when the page loads(resize doesn't get triggered when we reload page, tried using listener for load or DOMDocumentLoad but sometimes it doesn't work)
 * Resize listener updates the state when the viewport resizes(For some reason resize observer doesn't get triggered when resizing)
 */
export function useResize({ isEnabled = false }: { isEnabled: boolean }) {
  const ref = useRef<HTMLDivElement | null>(null);

  const [spacingLeftComputation, setSpacingLeftComputation] = useState(0);

  useEffect(() => {
    let observerRefValue = null;
    const calculateSpacingLeft = (entry: Element) => {
      if (isEnabled) {
        const computedStyle = window.getComputedStyle(entry);
        const margin = computedStyle.marginLeft;
        const padding = computedStyle.paddingLeft;
        setSpacingLeftComputation(parseInt(margin, 10) + parseInt(padding, 10));
      }
    };
    const handleResizeObserver = (entries: ResizeObserverEntry[]) => {
      for (const entry of entries) {
        calculateSpacingLeft(entry.target);
      }
    };

    const handleResize = () => {
      if (ref.current) {
        calculateSpacingLeft(ref.current);
      }
    };

    window.addEventListener('resize', handleResize);

    const observer = new ResizeObserver(handleResizeObserver);

    if (ref.current) {
      observer.observe(ref.current);
      observerRefValue = ref.current;
    }

    return () => {
      if (observerRefValue) {
        observer.unobserve(observerRefValue);
      }
      window.removeEventListener('resize', handleResize);
    };
  }, [isEnabled]);

  return { ref, spacingLeftComputation };
}
